const householdSituation = {
    "PARENTS_WITH_CHILDREN": "1",
    "TWO_ADULTS": "2",
    "ONE_ADULT": "3",
    "ONE_ADULT_WITH_CHILDREN": "4",
};
export default householdSituation;